import(/* webpackMode: "eager", webpackExports: ["TermsAndConditionsView"] */ "/Users/feker/Desktop/Feker-repo/ShahenWebsite/src/sections/terms-and-conditions/view/terms-and-conditions-view.jsx");
